import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import VideocallResponseType from "./typings/VideocallResponseType";

type VideocallGraphResponseType = {
  id: number;
  userType: string;
  count: number;
  date: string;
  orgId: number;
};
export default class VideocallService {
  static async listVideoCalls() {
    const apiConfig = {
      api: APIs.Videcall.ListRecord,
      parameters: null,
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as VideocallResponseType[];
  }

  static async getVideoCallRecord(fdate: string, todate: string) {
    const apiConfig = {
      api: APIs.Videcall.getVideoCallRecord,
      parameters: {
        "from": fdate,
        "to": todate
      },
      body: null,
    }
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as VideocallGraphResponseType[];
  }

  static async initiateVideoCallData(accessToken: string) {
    const apiConfig = {
      api: APIs.Videcall.InitiatCallData,
      parameters: null,
      body: {
        accessToken
      },
    };
    await SafeairManager.invoke(apiConfig);
  }
}
